import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';


import { HashRouter } from 'react-router-dom'

import DataCacheManager from './managers/DataCacheManager';

window.zzDataCache = new DataCacheManager();

ReactDOM.render(
    (<HashRouter hashType="slash">
        <App />
    </HashRouter>)
    , document.getElementById('app')
);

